import {
    BaseSubChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart';
import type {
    IAreaChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/area-chart.interface';
import type { IAreaChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class AreaChartProperty extends BaseSubChartProperty<IAreaChart> implements IAreaChartProperty {
    protected initFlattenData() {
        super.initFlattenData();

        const { dateAxes } = this.context.getChartModel().plotArea;
        // 如果坐标轴内categoryPoint有非数字string，则判定为非日期坐标轴
        // 理论上应该不会有这种情况， 但现在数据编辑时添加string类别后会出现这样的情况，后续修复
        const hasDateAxis = !!dateAxes?.length
            && this.series[0].dataList.every(data => !isNaN(Number(data.categoryPoint?.value)));

        this.data = this.data.map(item => (Object.assign(item, {
            category: (hasDateAxis && !isNaN(Number(item.category)))
                ? Number(item.category) : item.category,
        })));
    }

    // protected shouldApplyThemeStyle(uiData: any) {
    //     return !uiData?.props.style.fillBackground;
    // }
}
